import React, { useEffect, useRef } from 'react';

interface LazyLoadTriggerProps {
  onLoadMore: () => void;
  /** Rácsban átfogó osztály, pl. "col-span-2" */
  className?: string;
}

/**
 * Láthatatlan őrszem-elem lista végi lazy loadinghoz: amikor a görgetés
 * ~300px-re megközelíti, meghívja az onLoadMore-t. A szülő adja át `key`-ként
 * a látható elemszámot (key={visible.length}), így minden betöltött adag után
 * újra megfigyelés alá kerül, és görgetés nélkül is betölti a következő adagot,
 * ha az őrszem még mindig a látótérben van.
 */
const LazyLoadTrigger: React.FC<LazyLoadTriggerProps> = ({ onLoadMore, className = '' }) => {
  const ref = useRef<HTMLDivElement>(null);
  const callbackRef = useRef(onLoadMore);
  callbackRef.current = onLoadMore;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) callbackRef.current();
      },
      { rootMargin: '300px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return <div ref={ref} className={className} aria-hidden="true" />;
};

export default LazyLoadTrigger;
